<div class="catalog-content">
  <app-catalouge-add-team-member [MemberData]="tempMemberData"
    (refreshChange)="onRefresh()"></app-catalouge-add-team-member>
  <app-catalouge-list-team-members (editChange)="onTeamEdit($event)"></app-catalouge-list-team-members>
</div>